import $ from 'jquery';
import moment from 'moment';

const Events = function () {
    document.addEventListener('DOMContentLoaded', function () {
        const dropdownLocation = document.getElementById('locationDropdown');
        const dropdownEventType = document.getElementById('eventTypeDropdown');
        const dateFilterButton = document.getElementById('dateFilterButton');
        const dateFilterPopup = document.getElementById('dateFilterPopup');
        const dateFilterOptions = document.getElementsByName('dateFilter');
        const pickMonthContainer = document.getElementById('pickMonthContainer');
        const pickMonthLabel = document.getElementById('pickMonth');
        const pickMonthRadioButton = document.querySelector('input[name="dateFilter"][value="pick_a_month"]');
        const eventsContainer = document.getElementById('events-container');
        const paginationContainer = document.getElementById('pagination-container');
        const previousPageButton = document.getElementById('previous-page');
        const nextPageButton = document.getElementById('next-page');
        const noResultsContainer = document.getElementById('no-results-container');
        const locationSelectContainer = document.querySelector('.event-meta .location-select-container');
        const typeSelectContainer = document.querySelector('.event-meta .type-select-container');

        let currentPage = 1;
        let totalPages = 1;
        const itemsPerPage = 6;
        let filteredEvents = [];
        let dateFilterValue = '';

        let currentLocationValue = '';
        let currentEventTypeValue = '';
        let currentDateFilterValue = '';
        let currentPickMonthValue = '';

        const stateAbbreviations = {
            'AL': 'alabama', 'AK': 'alaska', 'AZ': 'arizona', 'AR': 'arkansas',
            'CA': 'california', 'CO': 'colorado', 'CT': 'connecticut', 'DE': 'delaware',
            'FL': 'florida', 'GA': 'georgia', 'HI': 'hawaii', 'ID': 'idaho',
            'IL': 'illinois', 'IN': 'indiana', 'IA': 'iowa', 'KS': 'kansas',
            'KY': 'kentucky', 'LA': 'louisiana', 'ME': 'maine', 'MD': 'maryland',
            'MA': 'massachusetts', 'MI': 'michigan', 'MN': 'minnesota',
            'MS': 'mississippi', 'MO': 'missouri', 'MT': 'montana',
            'NE': 'nebraska', 'NV': 'nevada', 'NH': 'new hampshire',
            'NJ': 'new jersey', 'NM': 'new mexico', 'NY': 'new york',
            'NC': 'north carolina', 'ND': 'north dakota', 'OH': 'ohio',
            'OK': 'oklahoma', 'OR': 'oregon', 'PA': 'pennsylvania',
            'RI': 'rhode island', 'SC': 'south carolina', 'SD': 'south dakota',
            'TN': 'tennessee', 'TX': 'texas', 'UT': 'utah', 'VT': 'vermont',
            'VA': 'virginia', 'WA': 'washington', 'WV': 'west virginia',
            'WI': 'wisconsin', 'WY': 'wyoming'
        };

        if (typeof jQuery === 'undefined' || typeof jQuery.fn.MonthPicker === 'undefined') {
            console.error('jQuery or MonthPicker is not loaded correctly.');
            return;
        }

        jQuery(pickMonthContainer).MonthPicker({
            Button: true,
            MonthFormat: 'yy-mm',
            ShowIcon: false,
            ShowButtonPanel: true,
            ChangeMonth: true,
            ChangeYear: true,
            OnBeforeMenuOpen: function () {
                enableMonthPickerControls();
            },
            OnAfterChooseMonth: function (selectedDate) {
                const month = selectedDate.getMonth() + 1;
                const year = selectedDate.getFullYear();
                const formattedMonthYear = `${getMonthName(month)} ${year}`;
                displaySelectedMonth(formattedMonthYear);
                // Update the filter state variables
                currentDateFilterValue = 'pick_a_month';
                currentPickMonthValue = `${year}-${month.toString().padStart(2, '0')}`;
                pickMonthRadioButton.checked = true;

                onTermChange();
            }
        });

        function getMonthName(monthIndex) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];
            return monthNames[monthIndex - 1];
        }

        function displaySelectedDateFilter(dateFilterLabel) {
            const $selectMonth = $('#selected-month');
            $selectMonth.text(dateFilterLabel + ' ');
            $selectMonth.append('<button class="clear-filter">&times;</button>');
            $selectMonth.show();
            dateFilterButton.style.display = 'none';
        }

        function displaySelectedMonth(monthYear) {
            const $selectMonth = $('#selected-month');
            $selectMonth.text(monthYear + ' ');
            $selectMonth.append('<button class="clear-filter">&times;</button>');
            $selectMonth.css('display', 'block');
            $selectMonth.show();
            $selectMonth.siblings('input[type="radio"]').prop('checked', true);
            dateFilterButton.style.display = 'none';
        }

        function displaySelectedLocation(locationTerm) {
            const dropdownLocation = $('#locationDropdown');
            const $selectLocation = $('#selected-location');
            const typeSelected = $('.event-meta #selected-type');
            const typeDropdown = $('#eventTypeDropdown');
            const $selectMonth = $('#selected-month');

            // Set the text of the span and append the button
            $selectLocation.text(formatLocationsText(locationTerm) + ' ');
            $selectLocation.append('<button class="clear-location-filter">&times;</button>');

            // Insert the span right after the dropdown and then hide the dropdown
            dropdownLocation.after($selectLocation);
            locationSelectContainer.classList.add('hide-after');

            dropdownLocation.hide();
            $selectLocation.show();

            // Reset any previously set classes for visibility combination
            typeSelected.removeClass('adjusted-top adjusted-both-visible');

            // Check the visibility combination of $selectMonth and typeSelected
            if (window.innerWidth < 768 && typeSelected.is(':visible') && $selectMonth.is(':visible')) {
                typeDropdown.css('top', '-7.5rem');
                typeSelected.addClass('adjusted-both-visible'); // Suppose adjusted-both-visible CSS is defined
            } else if (window.innerWidth < 768 && $selectMonth.is(':visible')) {
                typeSelected.addClass('adjusted-top');
            }

            // Set default positioning if conditions above aren't met
            if (window.innerWidth < 768 && typeSelected.css('top') !== '7.9rem') {
                typeDropdown.css('top', '-7.5rem');
                typeSelected.css('top', '-6.5rem');
            }
        }

        function displaySelectedType(typeTerm) {
            const dropdownType = $('#eventTypeDropdown');
            const $selectType = $('#selected-type');
            const $selectMonth = $('#selected-month');
            const $selectLocation = $('#selected-location');

            // Set the text of the span and append the button
            $selectType.text(formatEventTypeText(typeTerm) + ' ');
            $selectType.append('<button class="clear-type-filter">&times;</button>');

            // Insert the span right after the dropdown and then hide the dropdown
            dropdownType.after($selectType);
            typeSelectContainer.classList.add('hide-after');

            if (window.innerWidth < 768) {
                $selectType.css('top', '-7.8rem');
                $selectType.css('left', '6.5rem');
            }

            if ($selectLocation.is(':visible') && $selectMonth.is(':visible')) {
                // Both filters are visible
                $selectType.removeClass('adjusted-top adjusted-for-location');
                $selectType.addClass('adjusted-both-visible');
            } else if ($selectMonth.is(':visible')) {
                // Only the month filter is visible
                $selectType.removeClass('adjusted-both-visible adjusted-for-location');
                $selectType.addClass('adjusted-top');
            } else if ($selectLocation.is(':visible')) {
                // Only the location filter is visible
                $selectType.removeClass('adjusted-top adjusted-both-visible');
                $selectType.addClass('adjusted-for-location');
            } else {
                // No filters are visible
                $selectType.removeClass('adjusted-top adjusted-both-visible adjusted-for-location');
            }

            dropdownType.hide();
            $selectType.show();
        }

        function formatEventTypeText(text) {
            const words = text.split(' ');

            words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();

            return words.join(' ');
        }

        function formatLocationsText(text) {
            const words = text.split(' ');

            if (words.length > 0) {
                // Capitalize the first letter of the first word
                words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
                words[1] = words[1].charAt(0).toUpperCase() + words[1].slice(1).toLowerCase();
            }

            if (words.length > 1) {
                // Capitalize all letters of the last word
                const lastWordIndex = words.length - 1;
                words[lastWordIndex] = words[lastWordIndex].toUpperCase();
            }

            return words.join(' ');
        }

        $('input[type="radio"][name="dateFilter"]').change(function () {
            $('input[type="radio"][name="dateFilter"]').parent().removeClass('active');
            if ($(this).is(':checked')) {
                $(this).parent().addClass('active');
            }
        });

        function enableMonthPickerControls() {
            const prevButton = document.querySelector('.month-picker-previous a');
            const nextButton = document.querySelector('.month-picker-next a');

            if (prevButton && nextButton) {
                prevButton.classList.remove('ui-state-disabled');
                nextButton.classList.remove('ui-state-disabled');
            }
        }

        dateFilterButton.addEventListener('click', function (event) {
            event.stopPropagation();
            togglePopupDisplay();
        });

        document.addEventListener('click', function (event) {
            if (!dateFilterPopup.contains(event.target) && event.target !== dateFilterButton) {
                dateFilterPopup.style.display = 'none';
            }
        });

        dateFilterOptions.forEach(radio => {
            radio.addEventListener('change', function () {
                dateFilterValue = this.value;
                currentDateFilterValue = this.value;

                if (this.value === 'this_month') {
                    displaySelectedDateFilter('This Month');
                } else if (this.value === 'next_month') {
                    displaySelectedDateFilter('Next Month');
                } else if (this.value === 'pick_a_month') {
                    pickMonthContainer.style.display = 'block';
                    pickMonthContainer.click();
                    enableMonthPickerControls();
                    pickMonthRadioButton.checked = true;
                } else {
                    pickMonthContainer.style.display = 'none';
                    $('#selected-month').hide();
                }
                onTermChange();
            });
        });

        dropdownLocation.addEventListener('change', function () {
            if (dropdownLocation.value === '' && !dropdownEventType.value === '' && !dateFilterValue === '') {
                resetFilters();
            } else {
                onTermChange();
            }
        });

        dropdownEventType.addEventListener('change', function () {
            if (dropdownEventType.value === '' && !dropdownLocation.value === '' && !dateFilterValue === '') {
                resetFilters();
            } else {
                onTermChange();
            }
        });

        pickMonthContainer.addEventListener('change', onTermChange);

        function togglePopupDisplay() {
            if (dateFilterPopup && dateFilterPopup.style.display === 'none' || !dateFilterPopup.style.display) {
                dateFilterPopup.style.display = 'block';
            } else {
                dateFilterPopup.style.display = 'none';
            }
        }

        async function onTermChange() {
            currentLocationValue = dropdownLocation.value;
            currentEventTypeValue = dropdownEventType.value;

            if (currentLocationValue) {
                const eventLocationMapping = await updateEventLocationMapping();
                const expectedEventLocationText = eventLocationMapping[currentLocationValue]?.toLowerCase() || '';
                displaySelectedLocation(expectedEventLocationText);
            }
            if (currentEventTypeValue) {
                const eventTypeMapping = await updateEventTypeMapping();
                const expectedEventTypeText = eventTypeMapping[currentEventTypeValue]?.toLowerCase() || '';
                displaySelectedType(expectedEventTypeText);
            }
            filterEvents(currentLocationValue, currentEventTypeValue, currentDateFilterValue, currentPickMonthValue);
        }

        async function fetchEventTypes() {
            const baseUrl = `${sses.siteUrl}/wp-json/events/v1/event-types`;

            try {
                const response = await fetch(baseUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const eventTypes = await response.json();
                const eventTypeMapping = eventTypes.reduce((map, type) => {
                    map[type.id] = type.name;
                    return map;
                }, {});

                return eventTypeMapping;
            } catch (error) {
                console.error('Fetch failed:', error);
            }
        }

        async function updateEventTypeMapping() {
            const eventTypeMapping = await fetchEventTypes();
            return eventTypeMapping;
        }

        async function fetchEventLocations() {
            const baseUrl = `${sses.siteUrl}/wp-json/events/v1/event-locations`;

            try {
                const response = await fetch(baseUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const eventLocations = await response.json();
                const eventLocationsMapping = eventLocations.reduce((map, location) => {
                    map[location.id] = location.name;
                    return map;
                }, {});

                return eventLocationsMapping;
            } catch (error) {
                console.error('Fetch failed:', error);
            }
        }

        async function updateEventLocationMapping() {
            const eventLocationMapping = await fetchEventLocations();
            return eventLocationMapping;
        }

        function filterEvents(locationTermId, eventTypeTermId, dateFilterValue, pickMonthValue) {

            const eventCardsArray = Array.from(eventsContainer.getElementsByClassName('event-card'));
            const today = new Date();
            const currentMonth = today.getMonth() + 1;
            const currentYear = today.getFullYear();

            filteredEvents = eventCardsArray.filter(card => {
                const eventDate = new Date(card.dataset.eventDate);
                const eventYear = eventDate.getUTCFullYear();
                const eventMonth = eventDate.getUTCMonth() + 1;
                const cardLocationTerm = card.dataset.locationTerm.toLowerCase();
                const cardEventTypeTerm = card.dataset.eventTypeTerm.toLowerCase();

                let matchesDate = true;
                let matchesLocation = locationTermId ? (cardLocationTerm === locationTermId.toLowerCase()) : true;
                let matchesType = eventTypeTermId ? (cardEventTypeTerm.includes(eventTypeTermId.toLowerCase())) : true;

                if (dateFilterValue) {
                    if (dateFilterValue === 'this_month') {
                        matchesDate = (eventYear === currentYear && eventMonth === currentMonth);
                    } else if (dateFilterValue === 'next_month') {
                        const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
                        const nextMonthYear = nextMonth === 1 ? currentYear + 1 : currentYear;
                        matchesDate = (eventYear === nextMonthYear && eventMonth === nextMonth);
                    } else if (dateFilterValue === 'pick_a_month' && pickMonthValue) {
                        const [year, month] = pickMonthValue.split('-').map(Number);
                        matchesDate = (eventYear === year && eventMonth === month);
                    }
                }

                return matchesDate && matchesLocation && matchesType;
            });

            updateDisplay(filteredEvents);
            updateLocationDropdown(new Set(filteredEvents.map(card => card.dataset.locationTerm)));
        }

        async function filterSearch(searchTerm = '', locationTermId = '', eventTypeTermId = '', dateFilterValue = '', pickMonthValue = '') {
            const eventCardsArray = Array.from(eventsContainer.getElementsByClassName('event-card'));
            const eventTypeMapping = await updateEventTypeMapping();

            // Normalize the search term
            const cleanSearchTerm = searchTerm.trim().toLowerCase();

            filteredEvents = eventCardsArray.filter(card => {
                const postDate = $(card).data('event-date');
                const postMomentDate = moment(postDate, "YYYY-MM-DD");
                const postMonth = postMomentDate.format('MMMM').toLowerCase();

                const locationElementId = $(card).find('.event-card__content-location').attr('id');
                const postLocation = locationElementId ? locationElementId.split('-').pop().trim().toLowerCase() : '';
                const locationText = $(card).find('.event-card__content-location p').text().toLowerCase();

                let cardEventTypeId = $(card).data('event-type-term');
                cardEventTypeId = cardEventTypeId !== undefined ? cardEventTypeId.toString().trim() : '0';

                const expectedEventTypeText = eventTypeMapping[eventTypeTermId]?.toLowerCase() || '';
                const cardEventTypeText = eventTypeMapping[cardEventTypeId]?.toLowerCase() || '';

                const locationParts = locationText.split(',').map(part => part.trim());
                const cityName = locationParts[0].toLowerCase();  // Assuming city is the first part
                const stateAbbreviation = locationParts.length > 1 ? locationParts[1].toUpperCase() : '';
                const fullStateName = stateAbbreviations[stateAbbreviation];

                const expandedSearchTerms = [cleanSearchTerm];

                if (stateAbbreviation.toLowerCase() === cleanSearchTerm || (fullStateName && fullStateName.toLowerCase() === cleanSearchTerm)) {
                    expandedSearchTerms.push(stateAbbreviation.toLowerCase());
                    expandedSearchTerms.push(fullStateName.toLowerCase());
                }

                const searchMonthMatches = expandedSearchTerms.includes(postMonth);

                const searchTermMatch = [
                    $(card).find('.event-card__content-title h2').text().trim().toLowerCase().includes(cleanSearchTerm),
                    postLocation.includes(cleanSearchTerm),
                    cardEventTypeText.includes(cleanSearchTerm),
                    searchMonthMatches,
                    expandedSearchTerms.includes(stateAbbreviation.toLowerCase()),
                    (fullStateName && expandedSearchTerms.includes(fullStateName.toLowerCase())),
                    cityName.includes(cleanSearchTerm)   // Include city name in search match
                ];

                const matchesSearch = !cleanSearchTerm || searchTermMatch.some(match => match);
                const matchesLocation = !locationTermId || (postLocation === locationTermId.toString());
                const matchesType = !eventTypeTermId || (cardEventTypeText === expectedEventTypeText);

                let matchesDate = !dateFilterValue;
                if (dateFilterValue) {
                    switch (dateFilterValue) {
                        case 'this_month':
                            matchesDate = postMonth === moment().format('MMMM').toLowerCase();
                            break;
                        case 'next_month':
                            matchesDate = postMonth === moment().add(1, 'months').format('MMMM').toLowerCase();
                            break;
                        case 'pick_a_month':
                            const [year, month] = pickMonthValue.split('-').map(Number);
                            matchesDate = postMomentDate.year() === year && (postMomentDate.month() + 1) === month;
                            break;
                    }
                }

                return matchesSearch && matchesLocation && matchesType && matchesDate;
            });

            updateDisplay(filteredEvents);
        }

        function updateDisplay(eventCards) {
            if (!Array.isArray(eventCards)) {
                eventCards = Array.from(eventCards);
            }

            const allEventCards = eventsContainer.getElementsByClassName('event-card');

            if (eventCards.length === 0) {
                console.warn('No event cards match the filters.');
                noResultsContainer.style.display = 'grid';
                noResultsContainer.style.justifySelf = 'center';
                noResultsContainer.style.alignSelf = 'center';
                noResultsContainer.style.gridTemplateColumns = 'auto';

                // Hide all event cards
                Array.from(allEventCards).forEach(card => {
                    card.style.display = 'none';
                });

                paginationContainer.style.visibility = 'hidden';

                return;
            }

            noResultsContainer.style.display = 'none';
            noResultsContainer.style.gridTemplateColumns = 'auto auto auto';

            Array.from(allEventCards).forEach(card => {
                card.style.display = 'none';
            });

            const startIndex = (currentPage - 1) * itemsPerPage;
            const endIndex = Math.min(startIndex + itemsPerPage, eventCards.length);

            eventCards.slice(startIndex, endIndex).forEach(card => {
                card.style.display = 'block';
            });

            updatePagination(eventCards.length);
        }


        function updateLocationDropdown(visibleLocations) {
            const allLocationOptions = $('#locationDropdown option');
            allLocationOptions.each(function () {
                const optionValue = $(this).val();
                if (visibleLocations.has(optionValue) || optionValue === "") {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }

        function updatePagination(totalItems) {
            totalPages = Math.ceil(totalItems / itemsPerPage);
            previousPageButton.disabled = currentPage <= 1;
            nextPageButton.disabled = currentPage >= totalPages || totalPages === 0;
            paginationContainer.style.visibility = totalPages > 1 ? 'visible' : 'hidden';
        }

        previousPageButton.addEventListener('click', function () {
            if (currentPage > 1) {
                currentPage--;
                updateDisplay(filteredEvents);
            }
        });

        nextPageButton.addEventListener('click', function () {
            if (currentPage < totalPages) {
                currentPage++;
                updateDisplay(filteredEvents);
            }
        });

        jQuery(document).ready(function ($) {
            $('#events-search-form').on('submit', function (e) {
                e.preventDefault();
                const searchTerm = $('#search-events').val().toLowerCase();
                const selectedLocationTermId = $('#locationDropdown').val();
                const selectedEventTypeTermId = $('#eventTypeDropdown').val();

                let dateFilterValue = '';
                dateFilterOptions.forEach((radio) => {
                    if (radio.checked) {
                        dateFilterValue = radio.value;
                    }
                });
                const pickMonthValue = pickMonthContainer.value;

                filterSearch(searchTerm, selectedLocationTermId, selectedEventTypeTermId, dateFilterValue, pickMonthValue);
            });
        });

        document.querySelectorAll('.event-card').forEach(card => {
            const hasRibbon = card.querySelector('.event-card__ribbon');
            if (hasRibbon) {
                const contentLocation = card.querySelector('.event-card__content-location');
                if (contentLocation) {
                    contentLocation.classList.add('has-ribbon');
                }
            }
        });

        function resetFilters(filterToClear) {
            console.info(currentLocationValue);
            if (
                currentLocationValue === '' &&
                currentEventTypeValue === ''
            ) {
                filterToClear = 'all'; // Set to 'all' if all are already empty
            }

            switch (filterToClear) {
                case 'location':
                    currentLocationValue = '';
                    dropdownLocation.value = '';
                    $('#selected-location').hide().empty();
                    locationSelectContainer.classList.remove('hide-after');
                    dropdownLocation.style.display = 'block';
                    break;
                case 'eventType':
                    currentEventTypeValue = '';
                    dropdownEventType.value = '';
                    break;
                case 'date':
                    currentDateFilterValue = '';
                    currentPickMonthValue = '';
                    $('#selected-month').hide().empty();
                    dateFilterButton.style.display = 'flex';
                    pickMonthContainer.style.display = 'none';
                    $('input[name="dateFilter"]').prop('checked', false);
                    break;
                case 'all':
                    currentLocationValue = '';
                    dropdownLocation.value = '';
                    $('#selected-location').hide().empty();
                    locationSelectContainer.classList.remove('hide-after');
                    dropdownLocation.style.display = 'block';

                    currentEventTypeValue = '';
                    dropdownEventType.value = '';

                    currentDateFilterValue = '';
                    currentPickMonthValue = '';
                    $('#selected-month').hide().empty();
                    dateFilterButton.style.display = 'flex';
                    pickMonthContainer.style.display = 'none';
                    $('input[name="dateFilter"]').prop('checked', false);
                    break;
            }

            // Pass the current values to re-filter
            filterEvents(currentLocationValue, currentEventTypeValue, currentDateFilterValue, currentPickMonthValue);
        }

        function clearMonthSelection() {
            currentDateFilterValue = '';
            currentPickMonthValue = '';
            // Ensure UI Update and reset logic
            $('#selected-month').hide().empty();
            dateFilterButton.style.display = 'flex';
            $('input[name="dateFilter"]').prop('checked', false);
            resetFilters('date');
        }

        function clearLocationSelection() {
            const $selectLocation = $('#selected-location');
            const typeDropdown = $('#eventTypeDropdown');
            const typeSelected = $('.event-meta #selected-type');
            const $selectMonth = $('#selected-month'); // Make sure it's available if needed
            const isAnyOtherFiltersSet = $('#eventTypeDropdown').val() !== "" || currentDateFilterValue !== "";
            currentLocationValue = '';

            // Clear and hide the location display
            $selectLocation.hide().empty();
            dropdownLocation.value = '';
            dropdownLocation.style.display = 'block';
            locationSelectContainer.classList.remove('hide-after');

            // Remove any specific position adjustment classes
            typeSelected.removeClass('adjusted-top adjusted-both-visible');
            $selectMonth.removeClass('adjusted-top adjusted-both-visible');

            // Position type Dropdown and reset if top is not already set to a specific value
            if (window.innerWidth < 768) {
                typeDropdown.css('top', '-8.4rem');
                typeSelected.css('top', '-8rem');
                typeSelected.css('left', '7rem');
            }

            // Reset the filters if no other filters are set
            if (!isAnyOtherFiltersSet) {
                resetFilters('location');
            } else {
                // Reapply the current active filters
                filterEvents(currentLocationValue, currentEventTypeValue, currentDateFilterValue, currentPickMonthValue);
            }
        }

        function clearTypeSelection() {
            const $selectType = $('#selected-type');
            const isAnyOtherFiltersSet = $('#locationDropdown').val() !== "" || currentDateFilterValue !== "";
            currentEventTypeValue = '';

            // Clear and hide the location display
            $selectType.hide().empty();
            dropdownEventType.value = '';
            dropdownEventType.style.display = 'block';
            typeSelectContainer.classList.remove('hide-after');

            // Reset the filters if no other filters are set
            if (!isAnyOtherFiltersSet) {
                resetFilters('eventType');
            } else {
                // Reapply the current active filters
                filterEvents(currentLocationValue, currentEventTypeValue, currentDateFilterValue, currentPickMonthValue);
            }
        }

        $(document).on('click', '.clear-filter', function () {
            clearMonthSelection();
            resetFilters('date')
        });

        $(document).on('click', '.clear-location-filter', function () {
            clearLocationSelection();
        });

        $(document).on('click', '.clear-type-filter', function () {
            clearTypeSelection();
        });

        onTermChange(); // Initial filter call
    });
}

export default Events;